import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Provider, connect } from 'react-redux';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { get, isEmpty, find, cloneDeep } from 'lodash';
import rootReducer from '../../app-main/reducers';
import Contracts from '../../../../api/api-contracts';
import Transactable from 'shared-components/flow-transactable/transactable-main';
import { fetchBooking } from '../../app-main/actions/booking';
import { fetchContractsSnapshot } from '../../app-main/actions/contracts';
import ReviewRequestMain from '../../app-bookings-request/review-request-main';
import CustomOfferIOSModal from '../../app-bookings-custom/modals/custom-offer-ios-modal';
import { warningHeaders } from '../../app-bookings-request/data/trustAndSafetyData';
import { normalizeContracts, priceBreakdownObject } from '../../app-bookings-request/forms/bookingUtil';
import moment from 'moment';
import { injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ReviewRequestContainer extends Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: false,
      isAcceptDisabled: false,
      isAcceptSpinning: false
    };

    this.acceptBookingRequest = this.acceptBookingRequest.bind(this);
    this.acceptBooking = this.acceptBooking.bind(this);
    this.declineBookingRequest = this.declineBookingRequest.bind(this);
    this.createCustomOffer = this.createCustomOffer.bind(this);
    this.redirectToInboxDetails = this.redirectToInboxDetails.bind(this);
    this.acceptPayload = this.acceptPayload.bind(this);
  }

  componentDidMount () {
    const {
      dispatch,
      accessToken,
      routeParams,
      iosWebView = false,
      scrollTopIOS = null,
      token = ''
    } = this.props;

    if (iosWebView) {
      scrollTopIOS();
    }
    const bookingId = get(routeParams, 'bookingID') || this.props.bookingId;

    dispatch(fetchBooking(bookingId, accessToken || token));
    dispatch(fetchContractsSnapshot(bookingId, accessToken || token, (response) => {
      if (200 === response.statusCode) {
        const spaceRentalObj = find(get(response, 'pending'), { type: 'SPACE_RENTAL' }) || {};
        const riskObj = get(spaceRentalObj, 'meta.risk', {});
        const showTandSNotice = riskObj.should_warn_host && (riskObj.alcohol_consumed || riskObj.is_late_night);

        if (showTandSNotice) {
          analyticsIntegrations.reviewRequestWarningViewed(get(response, 'pending', []), riskObj);
        }
      }
    }));
  }

  componentWillReceiveProps (nextProps) {
    const { profile, booking } = nextProps;
    const isHost = profile.SSOid === get(booking, 'booking.host.ssoid');

    if (!isEmpty(booking.booking) && (!!profile.SSOid && !isHost)) {
      this.context.router.push({ pathname: '/inbox' });
    }
  }

  redirectToInboxDetails () {
    const { closeIOSModal, finalCb } = this.props;
    const bookingId = get(this.props, 'booking.booking._id');
    if (finalCb) {
      closeIOSModal();
      return finalCb();
    }
    this.context.router.push({ pathname: `/inbox/${bookingId}` });
  }

  declineBookingRequest () {
    const { toggleModal } = this.props;
    toggleModal('declineBkgRequestModal');
  }

  acceptPayload (tsWarningAccepted) {
    const { contract } = this.props;
    const spaceRentalObj = find(get(contract, 'data.pending'), { type: 'SPACE_RENTAL' }) || {};
    const riskObj = get(spaceRentalObj, 'meta.risk', {});
    const showTSWarning = riskObj.host_social_events_policy_agreement_required;

    const payload = {};
    if (showTSWarning) {
      payload.host_social_events_policy_accepted = tsWarningAccepted;
    }

    return payload;
  }

  acceptBookingRequest (tsWarningAccepted) {
    this.setState({ isAcceptDisabled: true, isAcceptSpinning: true });
    const { accessToken, profile } = this.props;
    const bookingId = get(this.props, 'booking.booking._id');
    const payload = this.acceptPayload(tsWarningAccepted);

    Contracts.updateRequest(payload, bookingId, accessToken, 'accept', (response) => {
      if (200 !== response.statusCode) {
        ReactDOM.render(
          <SharedIntlProviderHOC>
            <Transactable
              user={profile}
              intendedAction={() => this.acceptBooking(tsWarningAccepted)}
              hostFlag
              snoozeFeature
              zenDeskLocale={SharedIntlProviderHOC.getZendeskLocale()}
            />
          </SharedIntlProviderHOC>, document.getElementById('modal-container'));
      } else {
        this.redirectToInboxDetails();
      }
    });
  }

  acceptBooking (tsWarningAccepted) {
    const bookingId = get(this.props, 'booking.booking._id');
    const { accessToken } = this.props;
    const payload = this.acceptPayload(tsWarningAccepted);

    Contracts.updateRequest(payload, bookingId, accessToken, 'accept', (response) => {
      if (200 === response.statusCode) {
        this.redirectToInboxDetails();
      } else {
        this.setState({
          errorText: this.props.intl.formatMessage({ id: 'inbox.review_request_container.error', defaultMessage: 'Something went wrong, please try again.' }),
          isAcceptDisabled: false,
          isAcceptSpinning: false
        });
      }
    });
  }

  createCustomOffer () {
    const { iosWebView, profile, accessToken, finalCb } = this.props;
    const bookingId = get(this.props, 'booking.booking._id');
    if (iosWebView) {
      const store = createStore(rootReducer, applyMiddleware(thunk));
      ReactDOM.render(
        <Provider store={store}>
          <SharedIntlProviderHOC>
            <CustomOfferIOSModal
              offerAction="OFFER_CUSTOM_PRICE"
              accessToken={accessToken}
              bookingID={bookingId}
              user={profile}
              finalCb={finalCb}
              iosWebView
            />
          </SharedIntlProviderHOC>
        </Provider>, document.getElementById('modal-container'));
      return null;
    }
    this.context.router.push({ pathname: `/inbox/${bookingId}/offer-custom-price` });
  }

  render () {
    const {
      booking,
      contract,
      profile
    } = this.props;

    const ssoId = profile.SSOid;
    const currency = get(booking, 'booking.listing.prices[0].currency');

    const pendingContracts = get(contract, 'data.pending', []);
    const bookingDetails = get(booking, 'booking', {});

    const normalizedContracts = normalizeContracts(pendingContracts);
    const priceBreakdown = priceBreakdownObject(normalizedContracts);

    const {
      cleaningFee,
      spaceRentalSubtotal,
      spaceRentalTotal,
      itemsArray,
      addOnsTotal,
      total,
      hostPayout,
      hostFee,
      hostAddOnsSummary
    } = priceBreakdown;

    const cleaningFeeObj = find(bookingDetails.addtl_charges, { type: 'CLEANING_FEE' }) || {};
    const bookingCleaningFee = parseFloat(cleaningFeeObj.charge_amount).toFixed(2);

    const activityDetailBooking = cloneDeep(bookingDetails);
    if (!_.isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = 'HOST';
      activityDetailBooking.attendees = activityDetailBooking.number_of_guests;
      activityDetailBooking.spaceRental = spaceRentalTotal;
      activityDetailBooking.listing = get(booking, 'booking.listing', {});
      _.set(activityDetailBooking, 'guest.sso_id', _.get(booking, 'guest.ssoid'));
      delete activityDetailBooking.host;
    }

    return (
      <div className="ReviewRequestContainer ps-container-lg-margin ps-container-fixed">
        {
          (!isEmpty(contract.data) && !isEmpty(booking.booking))
            && <div className="full-width">
              <ReviewRequestMain
                {...this.props}
                booking={bookingDetails}
                bookingId={get(booking, 'booking._id')}
                activityDetailBooking={activityDetailBooking}
                masterContract={normalizedContracts.masterContract}
                spaceRentalObj={normalizedContracts.spaceRentalContract}
                spaceRentalSubtotal={spaceRentalSubtotal || bookingDetails.subtotal_amount}
                spaceRentalTotal={spaceRentalTotal || bookingDetails.subtotal_cf_drd}
                cleaningFee={cleaningFee || bookingCleaningFee}
                currency={currency}
                itemsArray={itemsArray}
                addOnsTotal={addOnsTotal}
                hostAddOnsSummary={hostAddOnsSummary}
                subtotal={total[ssoId] || bookingDetails.subtotal_cf_drd}
                processingFee={hostFee || bookingDetails.host_payout_processing_fee}
                total={hostPayout || bookingDetails.host_payout_amount}
                isHost
                ssoId={ssoId}
                redirectToInboxDetails={this.redirectToInboxDetails}
                acceptBookingRequest={this.acceptBookingRequest}
                declineBookingRequest={this.declineBookingRequest}
                createCustomOffer={this.createCustomOffer}
                errorText={this.state.errorText}
                isAcceptDisabled={this.state.isAcceptDisabled}
                isAcceptSpinning={this.state.isAcceptSpinning}
              />
            </div>
        }
      </div>
    );
  }
}

ReviewRequestContainer.propTypes = {
  booking: PropTypes.object,
  iosWebView: PropTypes.bool,
  contract: PropTypes.object,
  profile: PropTypes.object,
  dispatch: PropTypes.func,
  accessToken: PropTypes.string,
  routeParams: PropTypes.object,
  scrollTopIOS: PropTypes.func,
  token: PropTypes.string,
  bookingId: PropTypes.string,
  closeIOSModal: PropTypes.func,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string,
  finalCb: PropTypes.func,
  intl: intlShape
};

function mapStateToProps (state) {
  const { auth, booking, contract, profile } = state;
  const { accessToken } = auth;

  return {
    booking,
    accessToken,
    contract,
    profile
  };
}

ReviewRequestContainer.contextTypes = {
  router: PropTypes.object
};

export default injectIntl(connect(mapStateToProps)(ReviewRequestContainer));
